/* eslint-disable import/default */
import React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import './index.css'

const appRoot = document.getElementById('root') as HTMLElement
appRoot.setAttribute('notranslate', true)

createRoot(appRoot).render(<>
    {/*<React.StrictMode>*/}
    <App/>
    {/*</React.StrictMode>*/}
</>)


